import { RenterConfigInterface } from './Types';

const ConfigModel = (config?: RenterConfigInterface): RenterConfigInterface => {
  const {
    stripePublicKey = '',
    plaidEnv = '',
    plaidLinkToken = '',
    plaidLinkTokenExpiration = 0,
    enablePaymentStatus = false,
  } = config || {};

  return {
    stripePublicKey,
    plaidEnv,
    plaidLinkToken,
    plaidLinkTokenExpiration,
    enablePaymentStatus,
  };
};

export default ConfigModel;
